// @ts-ignore
import { createRequestActionNames } from 'helpers/redux/createRequestActionNames'

export const FEED_RECENT = createRequestActionNames('FEED_RECENT', ['GET'])
export const FEED_LEADER_BOARD_SET_SECTION = 'FEED/LEADER_BOARD_SET_SECTION'
export const FEED_SET_FILTER_BY_TEAM = 'FEED/SET_FILTER_BY_TEAM'
export const FEED_SET_FILTER_BY_RANGE = 'FEED/SET_FILTER_BY_RANGE'
export const FEED_SET_TAB = 'FEED/SET_TAB'
export const FEED_RECENT_FROM_SOCKETS = 'FEED/RECENT_FROM_SOCKETS'
export const FEED_STORY_FROM_SOCKETS = 'FEED/STORY_FROM_SOCKETS'
export const FEED_RECENT_LOAD_MORE = createRequestActionNames('FEED_RECENT_LOAD_MORE', ['GET'])

export const FEED_RECENT_ENABLE_GET_PENDING = 'FEED/RECENT_ENABLE_GET_PENDING'
export const FEED_RECENT_ENABLE_LOAD_MORE_PENDING = 'FEED/RECENT_ENABLE_LOAD_MORE_PENDING'
export const FEED_RECENT_SCROLL = 'FEED/RECENT_SCROLL'

export const FEED_STORIES = createRequestActionNames('FEED_STORIES', ['GET'])
export const FEED_STORIES_LOAD_MORE = createRequestActionNames('FEED_STORIES_LOAD_MORE', ['GET'])
export const FEED_STORIES_ENABLE_GET_PENDING = 'FEED/STORIES_ENABLE_GET_PENDING'
export const FEED_STORIES_ENABLE_LOAD_MORE_PENDING = 'FEED/STORIES_ENABLE_LOAD_MORE_PENDING'
export const FEED_STORIES_SCROLL = 'FEED/STORIES_SCROLL'
export const FEED_STORY_ACTIVITY = createRequestActionNames('FEED/STORY_ACTIVITY', ['GET'])

export const FEED_SET_EVENT_LIKE_OLD = 'FEED/SET_EVENT_LIKE_OLD'
export const FEED_SET_STORY_LIKE_OLD = 'FEED/SET_STORY_LIKE_OLD'

export const FEED_SET_REACTION = 'FEED/SET_REACTION'
export const FEED_UPDATE_REACTION = 'FEED/UPDATE_REACTION'
export const FEED_SET_REACTION_FROM_SOCKETS = 'FEED/FEED_SET_REACTION_FROM_SOCKETS'
export const FEED_UPDATE_REACTION_FROM_SOCKETS = 'FEED/FEED_UPDATE_REACTION_FROM_SOCKETS'

export const FEED_UPDATE_STORY_FROM_SOCKETS = 'FEED/UPDATE_STORY_FROM_SOCKETS'

export const FEED_REMOVE_UNREAD_STORY_AUTHOR = 'FEED_REMOVE_UNREAD_STORY_AUTHOR'
export const FEED_STORIES_UNREAD_COUNT = createRequestActionNames('FEED_STORIES_UNREAD_COUNT', ['GET'])
export const FEED_STORIES_MARKED_READ = createRequestActionNames('FEED_STORIES_MARKED_READ', ['GET'])

export const FEED_RESET_SOCKET_DATA = 'FEED/RESET_SOCKET_DATA'
